<template>
  <Notification v-if="showNotSupportedNotification" severity="error" class="margin-bottom-s">
    {{ marxentErrorMessage }}
  </Notification>
</template>

<script setup>
import Notification from '@atomic-ui/notification/Notification';
import useMarxent from '~/modules/marxent/composables/useMarxent';

const marxentErrorMessage = '"View In Your Room" is not supported on your device.';
const { showNotSupportedNotification } = useMarxent();
</script>
